/* rozmawiajMY — dodatki UX (10.10.2026)
   [1] karta gry: pasek „Do koszyka” widoczny zawsze, gdy głównego przycisku nie widać na ekranie
   [5] koszyk: przypięty pasek z sumą, gdy przycisku kasy nie widać na ekranie
   Stan jest ustawiany po klatce animacji, żeby nadpisać starszą logikę paska z rmy-site.js. */
(function(){
  if(!('IntersectionObserver' in window))return;
  function bind(barId,targetId){
    var bar=document.getElementById(barId),t=document.getElementById(targetId);
    if(!bar||!t)return;
    var visible=true;
    function apply(){
      var show=!visible;
      if(bar.classList.contains('show')!==show)bar.classList.toggle('show',show);
      if(document.body.classList.contains('sticky-on')!==show)document.body.classList.toggle('sticky-on',show);
    }
    new IntersectionObserver(function(en){
      visible=en[en.length-1].isIntersecting;
      requestAnimationFrame(function(){requestAnimationFrame(apply);});
    }).observe(t);
    new MutationObserver(function(){requestAnimationFrame(apply);}).observe(bar,{attributes:true,attributeFilter:['class']});
  }
  bind('stickyBuy','mainAdd');
  bind('cpBar','cpCheckout');
})();
